<template>
  <JyPagebody :activatedLoad="reloadData" class="newscate-tree-container">
    <TemplateList :title="title" lock-mode="grid" for-tree>
      <template slot="searchBar">
        <div class="mb-1 ml-md-2">
          <JyButton type="primary" @click="addRoot" is-outline>添加类别</JyButton>
        </div>
        <div class="mb-1 ml-md-2">
          <JyButton type="success" icon="refresh" title="刷新" @click="loadList" is-outline></JyButton>
        </div>
        <div class="mb-1 ml-md-2">
          <el-input v-model="searchData.name" size="small" placeholder="查询：名称/别名" style="width:13rem" clearable></el-input>
        </div>
        <div class="mb-1 ml-md-2">
          <JyButton type="primary" icon="search" class="mb-1 ml-md-1" @click="doSearch">查询</JyButton>
        </div>
      </template>
      <el-form slot="grid" v-loading="loadedData" label-width="0" :rules="rules" :model="editData" size="small" ref="editForm" class="p-4 newscate-tree-form">
        <div class="d-flex mb-2 pb-2 border-bottom newscate-tree-box flex-shrink-0 text-muted font-weight-bold" style="padding-left:24px;">
          <div class="item-name flex-shrink-0">名称</div>
          <div class="d-flex flex-grow-1">
            <div class="item-navname">别名</div>
            <!-- <div class="item-news">内容数</div> -->
            <div class="item-icon">分类小图标</div>
            <div class="item-outurl">外链</div>
            <div class="item-single">单内容</div>
            <div class="item-isnav">导航菜单<br>[父类有效]</div>
            <div class="item-needip">仅授权IP<br>可访问</div>
            <div class="item-needip">需要填写<br>审稿人</div>
            <div class="item-needip">需要统计<br>投稿数</div>
            <div class="ml-auto pr-4">操作</div>
          </div>
        </div>
        <el-tree
          ref="tree"
          :data="list"
          node-key="id"
          :filter-node-method="filterNode"
          default-expand-all
          :expand-on-click-node="false"
          @node-drag-start="handleDragStart"
          @node-drag-enter="handleDragEnter"
          @node-drag-leave="handleDragLeave"
          @node-drag-over="handleDragOver"
          @node-drag-end="handleDragEnd"
          @node-drop="handleDrop"
          draggable
          :allow-drop="allowDrop"
          :allow-drag="allowDrag"
          class="flex-grow-1"
        >
          <template v-slot="{node, data}">
            <div class="d-flex newscate-tree-box pt-1 pb-1 flex-grow-1">
              <div class="item-name flex-shrink-0" :style="{'padding-right': `${(node.level - 1) * 18}px`}">
                <form-item v-if="data.id == editId" label="" prop="name" fill="4">
                  <el-input v-model="editData.name"></el-input>
                </form-item>
                <div v-else><JyBadge v-if="data.id.startsWith('_temp')" type="danger">未保存</JyBadge>{{ data.name }}</div>
              </div>
              <div class="d-flex flex-grow-1 align-items-center" :style="{'margin-left': `${0 - (node.level - 1) * 18}px`}">
                <div class="item-navname">
                  <form-item v-if="data.id == editId" label="" prop="navname" fill="4">
                    <el-input v-model="editData.navname"></el-input>
                  </form-item>
                  <div v-else class="text-muted">{{ data.navname }}</div>
                </div>
                <!-- <div class="item-news">
                  <div class="text-muted">
                    <router-link v-if="data.id && !data.id.startsWith('_temp')" :to="'/admin/news?cateid='+ data.id">{{ data.countemp || 0 }}</router-link>
                  </div>
                </div> -->
                <div class="item-icon">
                  <form-item v-if="data.id == editId" label="" fill="4">
                    <el-upload
                      class="upload-demo"
                      :action="uploadPic"
                      :headers="headers"
                      :on-success="handleSuccess">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                      <div v-if="editData.icon">
                        <img :src="rootPath + editData.icon" style="height:2rem;">
                        <a href="javascript:;" class="text-danger" @click.stop="removeIcon">删除</a>
                      </div>
                    </el-upload>
                  </form-item>
                  <div v-else><img v-if="data.icon" :src="rootPath + data.icon" style="height:2rem;"></div>
                </div>
                <div class="item-outurl">
                  <form-item v-if="data.id == editId" label="" fill="4">
                    <el-input v-model="editData.outurl"></el-input>
                  </form-item>
                  <div v-else class="text-muted">{{ data.outurl }}</div>
                </div>
                <div class="item-single">
                  <form-item v-if="data.id == editId" label="" fill="4">
                    <el-switch v-model="editData.issingle"></el-switch>
                  </form-item>
                  <div v-else class="text-muted">{{ data.issingle ? '是' : '' }}</div>
                </div>
                <div class="item-isnav">
                  <form-item v-if="data.id == editId" label="" fill="4">
                    <el-switch v-model="editData.isnav"></el-switch>
                  </form-item>
                  <div v-else class="text-muted">{{ data.isnav ? '是' : '' }}</div>
                </div>
                <div class="item-needip">
                  <form-item v-if="data.id == editId" label="" fill="4">
                    <el-switch v-model="editData.needip"></el-switch>
                  </form-item>
                  <div v-else class="text-muted">{{ data.needip ? '是' : '' }}</div>
                </div>
                <div class="item-needip">
                  <form-item v-if="data.id == editId" label="" fill="4">
                    <el-switch v-model="editData.issgr"></el-switch>
                  </form-item>
                  <div v-else class="text-muted">{{ data.issgr ? '是' : '' }}</div>
                </div>
                <div class="item-needip">
                  <form-item v-if="data.id == editId" label="" fill="4">
                    <el-switch v-model="editData.istg"></el-switch>
                  </form-item>
                  <div v-else class="text-muted">{{ data.istg ? '是' : '' }}</div>
                </div>
                <div class="ml-auto pr-1">
                  <JyButton v-if="!data.id.startsWith('_temp') && !data.parentid && hasPermiss('news.cate.add')" type="info" class="ml-1" size="sm" @click.stop="addChild(data)">添加子分类</JyButton>
                  <JyButton v-if="data.id != editId && hasPermiss('news.cate.edit')" type="primary" class="ml-1" size="sm" @click.stop="doEdit(data)">编辑</JyButton>
                  <JyButton v-if="data.id == editId" type="success" class="ml-1" size="sm" is-outline @click.stop="doUpdate(node, data)">保存</JyButton>
                  <JyButton v-if="data.id == editId" type="danger" class="ml-1" size="sm" is-outline @click.stop="doCancel(node, data)">取消</JyButton>
                  <JyButton v-if="data.id != editId && hasPermiss('news.cate.del')" type="danger" class="ml-1" size="sm" is-outline @click.stop="doDel(node, data)">删除</JyButton>
                </div>
              </div>
            </div>
          </template>
        </el-tree>
      </el-form>
    </TemplateList>
  </JyPagebody>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/mutation-types';
import TemplateList from '../template-list.vue';
import tools from 'jyutils/tools';
import list from '../mixin/list';
import { arrayToTree, generateId } from 'jyutils/utils';
export default {
  components: {TemplateList },
  mixins: [tools, list],
  data() {
    return {
      title:'内容分类管理',
      searchData: {
        navname: '',
        name: ''
      },
      saveLoading: false,
      isFilter: false,
      editId: null,
      rules: {
        name: [{required:true, message:'名称必填！'}],
        navname: [{required:true, pattern:/^[A-Za-z0-9]+$/, min:2, max:15, message:'别名必填，不能有中文及特殊字符，2~15个字符！'}],
      }
    }
  },
  computed: {
    ...mapGetters({
      // loading: [types.BASE_LOAD.baseLoading],
      // statusLoading: [types.STATUS.statusLoading]
    }),
    listUrl() {
      return 'sys/newscate/list';
    },
    queryData() {
      return {};
    },
    defaultData() {
      return {id:null, name:'', navname:'', icon:null, outurl:'', issingle: false, seq:0, isnav: false, issgr: false, istg: false};
    }
  },
  watch: {
    reloadDepart() {
      this.loadList();
    },
    'searchData.name'() {
      this.doSearch();
    },
    'searchData.navname'() {
      this.doSearch();
    }
  },
  methods: {
    beforeLoad() {
      this.list = [];
      this.searchData.name = '';
    },
    reloadData() {
      if (!this.list || !this.list.length) {
        this.loadList();
      }
    },
    listOkcb(json) {
      this.list = arrayToTree(json);
    },
    doView() {

    },
    doEdit(data) {
      this.editData = Object.assign({}, data);
      this.editId = data.id;
    },
    removeIcon() {
      this.msgbox('确定要删除该icon吗？', () => {
        this.editData.icon = null;
      });
    },
    handleSuccess(res, file, filelist) {
      if (res.obj && res.obj.pic) {
        this.editData.icon = res.obj.pic;
        filelist.length = 0;
      } else {
        this.$message.error(res.message || '上传出错啦！');
      }
    },
    doUpdate(node, data) {
      this.submitform().then(() => {
        let changeData = JSON.stringify(this.editData), _data = JSON.stringify(data);
        if (changeData != _data) {
          this.$set(data, 'saveLoading', true);
          let postData = {};
          Object.assign(postData, this.editData);
          // 如果是新加
          if (postData.id.startsWith('_temp')) {
            postData.id = null;
          }
          // update to server
          this.doPost({
            url: 'sys/newscate/save',
            data: postData,
            okcb: (json) => {
              this.editId = null;
              Object.assign(data, json);
              // 更新vue
              // this.$store.commit(types.OTHER.reloadDepart);
              this.$store.dispatch(types.BASE_LOAD.newscateList, {reload: true});
            },
            cb: () => {
              this.$delete(data, 'saveLoading');
            }
          })
        } else {
          this.doCancel(node, data);
        }
      })
      .catch(() => {

      });
    },
    doCancel(node, data) {
      if (data.id.startsWith('_temp')) {
        const parent = node.parent;
        const children = parent.data.children || parent.data;
        const index = children.findIndex(d => d.id === data.id);
        children.splice(index, 1);
      }
      this.editId = null;
    },
    doDel(node, data) {
      this.msgbox('此操作将永久删除该类别, 是否继续?', () => {
        this.doPost({
          url: 'sys/newscate/del/'+ data.id,
          okcb: () => {
            this.loadList();
            this.$message.success('删除成功!');
          }
        });
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      if (!value.name && !value.companyid) return true;
      let flag = ((value.name && data.name.indexOf(value.name) != -1) || (value.companyid && data.companyid == value.companyid));
      return flag;
    },
    doSearch() {
      this.$refs.tree.filter(this.searchData);
    },
    addChild(parent) {
      // 如果有未保存的，不添加
      if (!this.editId) {
        let data = Object.assign({}, this.defaultData, {id: `_temp${generateId()}`, parentid: parent.id});
        if (!parent.children) {
          this.$set(parent, 'children', []);
        }
        data.seq = parent.children.length;
        parent.children.push(data);
        this.editData = Object.assign({}, data);
        this.editId = data.id;
      }

      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.tree.$el.querySelector('input').focus();
        }, 400);
      });
    },
    addRoot() {
      let data = Object.assign({}, this.defaultData, {id: `_temp${generateId()}`, seq: this.list.length});
      this.list.unshift(data);
      this.editData = Object.assign({}, data);
      this.editId = data.id;
    },
    // node, ev
    handleDragStart() {
      // console.log('drag start', node);
    },
    // draggingNode, dropNode, ev
    handleDragEnter() {
      // console.log('tree drag enter: ', dropNode.label);
    },
    // draggingNode, dropNode, ev
    handleDragLeave() {
      // console.log('tree drag leave: ', dropNode.label);
    },
    // draggingNode, dropNode, ev
    handleDragOver() {
      // console.log('tree drag over: ', dropNode.label);
    },
    // draggingNode, dropNode, dropType, ev
    handleDragEnd() {
      // console.log('tree drag end: ', dropNode && dropNode.label, dropType);
      // console.log()
    },
    // draggingNode, dropNode, dropType, ev
    handleDrop() {
      // 保存拖动节点
      this.loadedData = true;
      this.doPost({
        url: 'sys/newscate/saveOrder',
        data: this.list,
        okcb: () => {

        },
        cb: () => {
          this.$nextTick(() => this.loadedData = false);
        }
      });
    },
    allowDrop(draggingNode, dropNode, type) {
      // 一级节点不能拖动
      if (draggingNode.data.level == 0) {
        return false;
      }
      if (dropNode.data.level == 0) {
        return false;
      }
      // 二级节点不能被放置
      if (dropNode.data.level > 0) {
        return type != 'inner';
      }
      return true;
    },
    allowDrag(/*draggingNode*/) {
      // 编辑状态不允许拖动
      if (this.editId) {
        return false;
      }
      return true;
    }
  }
}
</script>
<style lang="less" scoped>
.newscate-tree-form {
  height:100%;
  .flex();
  flex-direction:column;
  /deep/ .el-tree {
    flex-grow:1;
    overflow-y:auto;
  }
}
.newscate-tree-form .el-tree-node__content{height:auto; min-height:26px;}
.newscate-tree-box{flex-shrink:0; align-items:center;}
.newscate-tree-box .item-name{width:160px;}
.newscate-tree-box .item-tel{width:200px;}
.newscate-tree-box .item-navname{width:150px;}
.newscate-tree-box .item-icon{width:120px;}
.newscate-tree-box .item-news{width:120px;}
.newscate-tree-box .item-outurl{width:160px;}
.newscate-tree-box .item-outurl > div {
  width:100%; overflow:hidden; text-overflow:ellipsis; white-space: nowrap;
}
.newscate-tree-box .item-single{width:100px;}
.newscate-tree-box .item-isnav{width:80px;}
.newscate-tree-box .item-needip{width:80px;}
.newscate-tree-container {
  /deep/ .el-tree-node__content {
    height:auto !important;
  }
  /deep/ .newscate-tree-form {
    .el-form-item--small.el-form-item{margin-top:2px; margin-bottom:5px;}
    .el-form-item__error{top:50%; left:auto; right:0; padding-right:3px; opacity:.8;}
  }
}
</style>
